export const gbp = (amount: number) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(amount);

export const dateShort = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "";

export const dateTimeShort = (iso: string | null | undefined) =>
  iso
    ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : "";

export const statusLabel: Record<string, string> = {
  draft: "Draft",
  submitted: "Awaiting manager",
  manager_approved: "Awaiting payroll",
  payroll_approved: "Approved for payment",
  rejected: "Rejected",
  recalled: "Recalled",
  paid: "Paid",
};

export const statusBadgeClass: Record<string, string> = {
  draft: "bg-slate-100 text-slate-700",
  submitted: "bg-amber-50 text-amber-700",
  manager_approved: "bg-amber-100 text-amber-800",
  payroll_approved: "bg-emerald-50 text-emerald-700",
  rejected: "bg-red-50 text-red-700",
  recalled: "bg-slate-100 text-slate-600",
  paid: "bg-emerald-100 text-emerald-800",
};

// Empty drafts (no lines) are purged by the daily 07:00 UTC job once they are
// older than EMPTY_DRAFT_DAYS. Returns the date a draft created at `createdAt`
// will go, formatted for people, so the UI can warn before it happens.
export const EMPTY_DRAFT_DAYS = 3;
export function emptyDraftDeleteDate(createdAt: string): string {
  const d = new Date(createdAt);
  d.setUTCDate(d.getUTCDate() + EMPTY_DRAFT_DAYS);
  return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
}
